export type Locale = (typeof locales)[number];

export const locales = [
  "en",
  "en-GB",
  "zh-CN",
  "zh-TW",
  "vi",
  "es",
  "de",
  "ko",
  "fr",
  "pt-PT",
  "pt-BR",
  "pl",
  "nl",
] as const;
export const defaultLocale: Locale = "en";
